<template>
  <v-data-table
    item-key="id"
    :items-per-page="5"
    :headers="headers"
    :items="dataFilter"
    loading-text="Đang Tải"
    no-data-text="Không có dữ liệu"
  >
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1"></td>
        <td colspan="1"><BaseSmallInput placeholder="Nhập NDCK" @change="val => filterItems(val, 'input')" /></td>
        <td v-if="step === 'done'" colspan="1">
          <BaseSmallSelect placeholder="Trạng thái" :items="filters" @change="val => filterItems(val, 'select')" />
        </td>
      </tr>
    </template>
    <template v-slot:[`item.amountMoney`]="{ item }">
      {{ formatMoney(item.amountMoney) }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <div v-if="item.status" :style="getColorStatus(item.status)">
        {{ getTextStatus(item.status) }}
        <span style="font-size: 12px; color: red" v-if="item.status === 'error'">({{ item.message || '' }})</span>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import BaseSmallSelect from '@/components/basic/BaseSmallSelect.vue'
import BaseSmallInput from '@/components/basic/input/BaseSmallInput.vue'
export default {
  components: {
    BaseSmallSelect,
    BaseSmallInput,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    step: String,
  },
  data() {
    return {
      dataFilter: [],
      items: [],
      filters: [
        {
          text: 'Lỗi',
          value: 'error',
        },
        {
          text: 'Thừa',
          value: 'over',
        },
        {
          text: 'Thiếu',
          value: 'under',
        },
        {
          text: 'Đủ',
          value: 'correct',
        },
      ],
      headers: [
        {
          text: 'Số tiền',
          value: 'amountMoney',
          align: 'right',
          sortable: false,
          width: '170px',
        },
        {
          text: 'Nội dung chuyển khoản',
          value: 'reference',
          align: 'left',
          sortable: false,
        },
      ],
    }
  },
  methods: {
    getTextStatus(status) {
      switch (status) {
        case 'error':
          return 'Lỗi'
        case 'under':
          return 'Thiếu'
        case 'over':
          return 'Thừa'
        case 'correct':
          return 'Đủ'
        default:
          break
      }
    },
    getColorStatus(status) {
      switch (status) {
        case 'error':
        case 'under':
          return 'color: red'
        case 'over':
          return 'color: green'
        default:
          break
      }
    },
    filterItems(val, type) {
      if (val === '') return (this.dataFilter = this.items)
      if (type === 'input') {
        this.dataFilter = this.items.filter(i => i.reference.includes(val))
      }
      if (type === 'select') {
        this.dataFilter = this.items.filter(i => i.status === val)
      }
    },
    formatMoney(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  watch: {
    data: {
      handler(val) {
        this.items = val
        this.dataFilter = val
      },
      immediate: true,
      deep: true,
    },
    step: {
      handler(val) {
        if (val == 'done')
          this.headers = [
            {
              text: 'Số tiền',
              value: 'amountMoney',
              align: 'right',
              sortable: false,
              width: '170px',
            },
            {
              text: 'Nội dung chuyển khoản',
              value: 'reference',
              align: 'left',
              sortable: false,
            },
            {
              text: 'Trạng thái',
              value: 'status',
              align: 'center',
              sortable: false,
            },
          ]
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style></style>
